import React from 'react';
import { Button, Grid, Typography, Container, Box } from '@material-ui/core';
import Layout from '../Layout';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import CustomBreadcrumbs from '../Breadcrumb';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { redisDeleteAll } from '../../ReduxStore/MastertableSlice';




const Redis = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Settings', href: '/settings' }
    ];


    const redisHandler = async () => {
        try {
            const action = dispatch(redisDeleteAll());
            const res = await action.unwrap();
            if (res.StatusCode === 200) {
                toast.success("Success!");
            } else {
                toast.error("Something went wrong!")
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    }


    return (
        <Layout>
            <Container>
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Redis" />
                </Box>
                <Box mb={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Redis Delete
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => redisHandler()}
                                style={{ marginTop: '10px' }}
                            >
                                Delete Redis
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default Redis;
